module.exports = __webpack_public_path__ + "static/media/pointsCard.50a8f2f7.png";